import { API } from '@consts/urls';
import axios, { type AxiosResponse } from 'axios';
import { createUri, Api } from './utils';


const DATA_URL = createUri(Api.ReportsV2, '/reporting/V1');

export const dataApi = axios.create({
    baseURL: DATA_URL,
});

const handleFetch = async (url: string, token: string, params?: { [key: string]: any }): Promise<any> => {
    const resp = await dataApi
        .get(url, {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .catch(async () => {
            return null;
        });

    return resp ? resp.data : null;
};

export const fetchReportV2 = async (reportType: string, token: string, params?: { [key: string]: any }): Promise<any> => {
    const url: string = API[reportType];

    return await handleFetch(url, token, params);
};

/**
 * This function is used to modify the cut dates in the database.
 * @returns true if successful, false otherwise
 */
export const fetchModifyCuts = async (cutJSON: { CutID: string, Date: string, Time: string }[], token: string) => {
    const resp = await dataApi.post(
        '/cutModifier',
        cutJSON,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    ).catch(async () => {
        return false;
    });

    return {
        success: resp ? (resp as AxiosResponse).status === 200 : false,
        numRows: resp ? (resp as AxiosResponse).data : 0,
    };
};
